(function () {
  'use strict';

  function forceStyle(el, prop, value) {
    if (el) el.style.setProperty(prop, value, 'important');
  }

  function fixDesktopHeader() {
    if (window.matchMedia('(max-width: 989px)').matches) return;
    if (document.body.classList.contains('template-index')) return;

    const section = document.querySelector('.shopify-section-group-header-group.header-bottom-section.section-header:not(.section-header-bottom)');
    if (!section) return;

    section.classList.add('z86-header-section');
    const sticky = section.querySelector(':scope > sticky-header.header-wrapper, :scope > .header-wrapper');
    const header = section.querySelector('.header');
    const notification = section.querySelector(':scope > cart-notification');

    [section, sticky, header].forEach(function (el) {
      forceStyle(el, 'height', '72px');
      forceStyle(el, 'min-height', '72px');
      forceStyle(el, 'max-height', '72px');
      forceStyle(el, 'margin', '0');
    });

    forceStyle(section, 'padding', '0');
    forceStyle(section, 'overflow', 'visible');
    forceStyle(sticky, 'padding', '0');
    forceStyle(sticky, 'overflow', 'visible');

    if (notification) {
      forceStyle(notification, 'position', 'absolute');
      forceStyle(notification, 'top', '72px');
      forceStyle(notification, 'left', '0');
      forceStyle(notification, 'right', '0');
      forceStyle(notification, 'height', '0');
      forceStyle(notification, 'min-height', '0');
      forceStyle(notification, 'max-height', '0');
      forceStyle(notification, 'margin', '0');
      forceStyle(notification, 'padding', '0');
      forceStyle(notification, 'overflow', 'visible');
    }

    const bottom = document.querySelector('.shopify-section-group-header-group.section-header.section-header-bottom');
    if (bottom) forceStyle(bottom, 'margin-top', '0');
  }

  function getProductVariants() {
    const dataEl = document.getElementById('ZypherV86ProductVariants');
    if (!dataEl) return [];
    try {
      return JSON.parse(dataEl.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function getCurrentVariant(variants) {
    if (!variants.length) return null;

    const picker = document.querySelector('variant-radios, variant-selects');
    if (picker && picker.currentVariant) return picker.currentVariant;

    const formInput = document.querySelector('product-form input[name="id"], form[action*="/cart/add"] input[name="id"]');
    const id = formInput ? Number(formInput.value) : 0;
    if (id) {
      const found = variants.find(function (variant) { return Number(variant.id) === id; });
      if (found) return found;
    }

    const urlVariant = Number(new URLSearchParams(window.location.search).get('variant'));
    if (urlVariant) {
      const found = variants.find(function (variant) { return Number(variant.id) === urlVariant; });
      if (found) return found;
    }

    return variants.find(function (variant) { return variant.available; }) || variants[0];
  }

  function updateProductMeta() {
    if (!document.body.classList.contains('template-product')) return;

    const info = document.querySelector('.product__info-container');
    if (!info) return;

    /* Remove the old V86 injected rows if the browser has cached prior JS. */
    info.querySelectorAll('.z86-product-meta').forEach(function (row) { row.remove(); });

    const variants = getProductVariants();
    const variant = getCurrentVariant(variants);
    if (!variant) return;

    const skuValue = info.querySelector('.z87-product-sku-value');
    const barcodeValue = info.querySelector('.z87-product-barcode-value');
    if (skuValue) skuValue.textContent = variant.sku || 'N/A';
    if (barcodeValue) barcodeValue.textContent = variant.barcode || 'N/A';

    /* Hide any legacy SKU block elsewhere in the info stack so SKU only
       appears once, directly under Category. */
    info.querySelectorAll('.product__type .sku-name').forEach(function (oldSkuLabel) {
      const row = oldSkuLabel.closest('.product__type');
      if (row && !row.classList.contains('z87-product-meta')) row.style.display = 'none';
    });
  }

  function fixAccountDropdown() {
    document.querySelectorAll('.tm_header-dropdown .my-account a').forEach(function (link) {
      link.style.setProperty('color', '#172231', 'important');
      link.style.setProperty('visibility', 'visible', 'important');
      link.style.setProperty('opacity', '1', 'important');
    });
  }

  function init() {
    fixDesktopHeader();
    updateProductMeta();
    fixAccountDropdown();

    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest && event.target.closest('variant-radios, variant-selects')) {
        window.setTimeout(updateProductMeta, 0);
      }
    });

    window.addEventListener('resize', function () {
      window.clearTimeout(window.__z86HeaderResizeTimer);
      window.__z86HeaderResizeTimer = window.setTimeout(fixDesktopHeader, 80);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
